export function getLocale(language) {
  return language?.startsWith("en") ? "en" : "pl";
}

function toLocalDate(dateString) {
  return new Date(`${dateString}T12:00:00`);
}

export function formatDisplayDate(dateString, locale) {
  return new Intl.DateTimeFormat(locale === "en" ? "en-US" : "pl-PL", {
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(toLocalDate(dateString));
}

export function formatShortDate(dateString, locale) {
  return new Intl.DateTimeFormat(locale === "en" ? "en-US" : "pl-PL", {
    day: "numeric",
    month: "short",
  }).format(toLocalDate(dateString));
}
